module.exports = __webpack_public_path__ + "img/MD.34eba4e9.svg";